<tt-card *ngIf="!!get" [ttHeading]="get.heading" ttTranslateHeading="false" style="display: block; max-width: 50rem">
    <tt-input ttLabel="usergroup_keyno" [ttModel]="get.usergroup_keyno" ttReadonly></tt-input>
    <tt-input ttLabel="usergroup_name" [(ttModel)]="get.usergroup_name"></tt-input>
    <tt-checkbox ttLabel="dba_rights" [(ttModel)]="get.dba_rights"></tt-checkbox>
    <tt-checkbox ttLabel="is_terminal_group" [(ttModel)]="get.is_terminal_group"></tt-checkbox>
    <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    <tt-button *ngIf="get.show_delete === '1'" ttText="delete" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteUserGroup()"></tt-button>
    <tt-tabs [(ttSelectedId)]="selectedTabId">
        <tt-tab ttId="USERS" ttLabel="users"></tt-tab>
        <tt-tab ttId="WEBPAGES" ttLabel="webpages"></tt-tab>
    </tt-tabs>
</tt-card>
<tt-grid [hidden]="(!!get && '' + get.usergroup_keyno === '0') || selectedTabId !== 'USERS'" *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
<tt-grid [hidden]="(!!get && '' + get.usergroup_keyno === '0') || selectedTabId !== 'WEBPAGES'" *ngIf="!!gridwebpage" [(ttOptions)]="gridwebpage"></tt-grid>
